function buildItem(channels) {
    const {
        name,
        catalog_url,
        thumbnail,
        TotalPresentationCount,
        LastModified,
        description,
    } = channels;

    return `<li class="channel">
    <div class="channel-name channel__header">${name}</div>
    <div class="channel-thumbnail channel__body">
        <a href="${catalog_url}" class="channel-thumbnail-view channel__link">
            <div class="channel__row">
                <div class="channel__thumbnail-wrapper">
                    <div class="channel__thumbnail">
                        <img alt="Digital Media thumbnail for ${name}" src="${thumbnail}">
                    </div>
                </div>
                <div class="channel__metrics">
                    <div class="channel-presentation-count channel__presentation-count">${TotalPresentationCount} videos in this channel </div>
                    <div class="channel-update-date channel__last-update">Updated ${LastModified}</div>
                </div>
            </div>
            <div class="channel__row">
                <div class="channel-description channel__description">${description}</div>
            </div>
        </a>
    </div>
    </li>`;
}

function buildEtuiItem(channels) {
    const {
        name,
        catalog_url,
        thumbnail,
        TotalPresentationCount,
        description,
        LastModified,
    } = channels;

    return `<div class="col-md-6 mb-4">
            <a class="etui link-reset text-decoration-none" href="${catalog_url}" target="blank">
                <div class="card h-100 external image-divider title-sm">
                    <img class="card-img-top" src="${thumbnail}" alt="Digital Media thumbnail for ${name}">
                    <div class="card-body">
                        <div class="card-title">${name}</div>
                        <div class="card-text">
                            Updated ${LastModified} &#183; ${TotalPresentationCount} videos in this channel
                            <div>${description}</div>
                        </div>
                    </div>
                </div>
            </a>
            </div>`;
}

function init(data, isEtui) {
    let html;
    const container = document.querySelector('#channel-list__wrapper');

    if (isEtui) {
        html = data.map(buildEtuiItem);
        container.innerHTML = `<div class="row g-5">${html.join("")}</div>`;
    } else {
        html = data.map(buildItem);
        container.innerHTML = `${html.join("")}`;
    }
}

global.buildChannels = {
    render: init,
};